const RunnersOn = {
    NoRunners:        { key: 0,     name: 'No Runners',              short: 'None'},
    First:            { key: 1,     name: 'Runner on 1st',           short: '1st'},
    Second:           { key: 2,     name: 'Runner on 2nd',           short: '2nd'},
    Third:            { key: 4,     name: 'Runner on 3rd',           short: '3rd'},
    FirstAndSecond:   { key: 3,     name: 'Runners on 1st & 2nd',    short: '1st & 2nd'},
    FirstAndThird:    { key: 5,     name: 'Runners on 1st & 3rd',    short: '1st & 3rd'},
    SecondAndThird:   { key: 6,     name: 'Runners on 2nd & 3rd',    short: '2nd & 3rd'},
    All:              { key: 7,     name: 'All bases',               short: 'All'},
    Unidentified:     { key: 'UI',  name: 'Unidentified',            short: '-'},
};

export default RunnersOn;